<template>
    <div>

        <div v-if="isErr">
            <app-error
                v-bind:parentError="{
                    data: this.errMsg,
                    isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
            />
        </div>

        <v-container>
            <v-form ref="form">

                <v-row>
                    <div class="pt-2 pl-8 pb-5">
                        <v-row>
                        <v-col>
                        <v-btn 
                            color="warning" 
                            style="width: 70px;"
                            @click="backHandler" 
                            > 
                            {{$t('button.back')}}
                        </v-btn>
                        </v-col>

                        </v-row>

                    </div>
                </v-row>
                
                <v-container
                    id="scroll-target"
                    overflow-y-auto
                    class="custom-form px-5"
                >

                    <div>
                        <v-row>
                            <h3 class="pt-2 pb-3 pl-3">{{ this.parentObject.pageTitle }}</h3>
                        </v-row>

                        <v-row>
                            <v-col cols="8" class="pb-n5">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.description')"
                                    ref="description"
                                    readonly
                                    v-model="readOnly.description"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="8" class="pb-n5 mt-n6">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercisesectioncard.goal')"
                                    ref="goal"
                                    readonly
                                    v-model="readOnly.goal"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="8" class="mt-n6 mb-2 big-text-field">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercisesectioncard.KPI')"
                                    ref="kpi"
                                    readonly
                                    v-model="readOnly.kpi"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="6" class="pb-n4 mt-n8 ml-3">
                                <v-row>
                                    <v-col cols="4" sm="4" class="pl-0">
                                        <v-text-field
                                            outlined
                                            :label="$t('columns.target')"
                                            type="text"
                                            v-model="readOnly.target"
                                            dense
                                            class="v-input"
                                            readonly
                                            background-color="#ffeab2"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="4" sm="4" class="px-0">    
                                        <v-text-field
                                            outlined
                                            :label="$t('Setupformreviewsection.weightage')"
                                            type="text"
                                            v-model="readOnly.weightage"
                                            dense
                                            class="v-input"
                                            readonly
                                            background-color="#ffeab2"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </div>

                    <div>
                        <v-row>
                            <app-table
                                v-bind:parentObject = "{
                                    tabHeader: this.tabHeader,
                                    formData: this.formData,
                                    calcMethod: this.readOnly.pmcalmethodid,
                                    target: this.readOnly.target,
                                }"
                            />
                        </v-row>
                    </div>
                </v-container>

            </v-form>
        </v-container>
    </div>
</template>

<script>
import moment from "moment";
import CRUDTable from './CRUDTableCommonKPI';

export default {
    props: {
        parentObject: Object
    },

    components: {
       'app-table': CRUDTable,
    },


    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || this.$t('periodicincentivesetup.invalidemail');
                }
            },

            readOnly: this.parentObject.data.commonDetails,

            formData: {
                commonkpiid: this.$route.params.id,
                reviewdate: null,
                achievement: null,
                comments: null,
                stamp: 0,
                userid: this.$store.getters.userId,
                progress: null,
                target: null,
                calcMethod : null
            },

            errMsg: "",
            isErr: false,

            progressCommonKpiListdetail: [],
            loadingCommonKpiProgress: false,

            tabHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '100px', sortable: false},
                { text: this.$t('pmreviewexercisesectioncard.reviewdate'), value: 'reviewdate', width: '200px', sortable: true},
                { text: this.$t('pmreviewexercisesectioncard.achievement'), value: 'achievement', width: '200px', sortable: true},
                { text: this.$t('pmreviewexercisesectioncard.progress'), value: 'progress', width: '200px', sortable: true},
                { text: this.$t('performancemanagement.comments'), value: 'comments', width: '200px', sortable: true},
            ],

            //load kpi common list handler
            async loadKpiCommonListHandler() {
                const vm = this;
                vm.loadingCommonKpiProgress = true;

                await this.$store.dispatch('get', {url: "/kpicommonprogress/" + vm.$route.params.id})
                .then((res) => {

                    for(let i = 0; i < res.data.rec.length; i++) {
                        
                        if(res.data.rec[i].reviewdate){
                            res.data.rec[i].reviewdate = moment(res.data.rec[i].reviewdate).format('YYYY-MM-DD');
                        }
                    }
                    
                    vm.progressCommonKpiListdetail = res.data.rec;
                    vm.loadingCommonKpiProgress = false;
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
            },
        }
    },

    methods: {
        backHandler(){
            this.$router.push({name: 'kpisettingedit', params: { id: this.parentObject.data.kpiexerid } });
        },
    }, 

    created() {
        this.loadKpiCommonListHandler();
    },
}
</script>

<style scoped>
.big-text-field .v-input__slot{
    height: 100px;
}

#input-35 {
    margin-top: -50px;
}
</style>
